import { styled } from "@linaria/react";
import type { ReactNode } from "react";

const Frame = styled.div<{ $fillHeight: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  min-height: 0;
  flex: ${({ $fillHeight }) => ($fillHeight ? "1 1 0" : "0 0 auto")} !important;
  overflow: hidden;
`;
const Body = styled.div<{ $fillHeight: boolean }>`
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  flex: ${({ $fillHeight }) => ($fillHeight ? "1 1 0" : "0 0 auto")};
  overflow: hidden;
`;
export function TableLayout({
  children,
  footer,
  fillHeight = true,
}: {
  children: ReactNode;
  footer: ReactNode;
  fillHeight?: boolean;
}) {
  return (
    <Frame $fillHeight={fillHeight}>
      <Body $fillHeight={fillHeight}>{children}</Body>
      {footer}
    </Frame>
  );
}
